export default __webpack_public_path__ + "static/media/sub-app-bill-split-pic.94d2f04cee76c0b1a7cde67e26b7c6ab.jpg";